import { render } from "./ConversionSalesProductsCategories.vue?vue&type=template&id=3ff0fbca&scoped=true"
import script from "./ConversionSalesProductsCategories.vue?vue&type=script&lang=js"
export * from "./ConversionSalesProductsCategories.vue?vue&type=script&lang=js"

import "./ConversionSalesProductsCategories.vue?vue&type=style&index=0&id=3ff0fbca&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff0fbca"]])

export default __exports__